// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"ee2dcb5a","239":"4e96c04c","455":"cfd9d6a3","488":"42958b9a","977":"8c64694a"}[chunkId] + ".chunk.js";
};